import script from "./question_check.vue?vue&type=script&setup=true&lang=ts"
export * from "./question_check.vue?vue&type=script&setup=true&lang=ts"

import "./question_check.vue?vue&type=style&index=0&id=77ae006a&scoped=true&lang=css"

import exportComponent from "/var/www/ShareMentors/ShareMentors/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77ae006a"]])

export default __exports__